import axios from 'axios';

export default class API {

    static getRetrieve(requestPath, dataDescription, authToken, setActionResponse) {
        const headers = {
            'Authorization': `Bearer ${authToken}`,
            'Accept': "application/json",
            'Access-Control-Allow-Origin': requestPath
        };

        axios.get(requestPath, { headers })
            .then(response => {
                const actionResponse = response.data;
                actionResponse.requestType = dataDescription;
                setActionResponse(actionResponse);
            })
            .catch(error => {
                let message;
                if (typeof(error.response) !== 'undefined' && error.response.status === 401) {
                    message = 'Unauthorized request';
                } else {
                    message = error.message;
                }
                const actionResponse = {
                    error: true,
                    errorMessage: message,
                    requestType: dataDescription
                };
                setActionResponse(actionResponse);
            });
    }

    static postAction(requestPath, data, dataDescription, authToken, setActionResponse) {
        const options = {
            method: 'post',
            url: requestPath,
            data: data,
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': "application/json",
                'Accept': "application/json",
                'Access-Control-Allow-Origin': requestPath
            }
        };

        axios(options)
            .then(response => {
                let actionResponse;
                if (response.data) {
                    actionResponse = response.data;
                    actionResponse.requestType = dataDescription;
                } else {
                    actionResponse = {
                        error: true,
                        errorMessage: 'No response data received',
                        requestType: dataDescription
                    }
                }
                setActionResponse(actionResponse);
            })
            .catch(error => {
                let message;
                if (typeof(error.response) !== 'undefined' && error.response.status === 401) {
                    message = 'Unauthorized request';
                } else {
                    message = error.message;
                }
                const actionResponse = {
                    error: true,
                    errorMessage: message,
                    requestType: dataDescription
                };
                setActionResponse(actionResponse);
            });
    }

    /**
     * Fire-and-forget diagnostic post. Deliberately takes no setActionResponse and returns
     * nothing: it must never touch component state, because everything that flows through
     * setActionResponse drives the payment state machine. Uses a keepalive fetch so the
     * report still leaves the browser when the page is being unloaded.
     *
     * Deliberately not sendBeacon: a beacon is always sent with credentials mode
     * 'include', and the browser rejects that against the wildcard
     * Access-Control-Allow-Origin the API returns, so cross-origin beacons were queued
     * and then silently dropped. keepalive gives the same unload guarantee without
     * forcing credentials on the request.
     */
    static logEvent(requestPath, data) {
        try {
            fetch(requestPath, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {'Content-Type': 'application/json'},
                keepalive: true
            }).catch(() => {});
        } catch (e) {
            // Diagnostics must never disturb the payment flow.
        }
    }

    static postForFile(requestPath, data, dataDescription, authToken, setFileResponse) {
        const options = {
            method: 'post',
            responseType: 'blob',
            url: requestPath,
            data: data,
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': "application/json",
                'Accept': ["application/pdf","application/json"],
                'Access-Control-Allow-Origin': requestPath
            }
        };

        axios(options)
            .then(response => {
                if (response.data) {
                    setFileResponse(response.data);
                } else {
                    const actionResponse = {
                        error: true,
                        errorMessage: (response.data.message),
                        requestType: dataDescription
                    }
                    setFileResponse(actionResponse);
                }
            })
            .catch(error => {
                const message = (typeof(error.response) !== 'undefined' && error.response.status === 401) ?
                    'Your session has expired and you must login again' :
                    `An error occurred processing your request: ${error.message}`;
                const actionResponse = {
                    error: true,
                    errorMessage: message
                };
                setFileResponse(actionResponse);
            });
    }

    static getBinary(requestPath, authToken, setFile, setErrorResponse) {
        const options = {
            method: 'get',
            responseType: 'blob',
            url: requestPath,
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Accept': 'application/octet-stream',
                'Access-Control-Allow-Origin': requestPath
            }
        };

        axios(options)
            .then(response => {
                if (response.data) {
                    setFile(response.data);
                } else {
                    const actionResponse = {
                        error: true,
                        errorMessage: (response.data.message)
                    }
                    setErrorResponse(actionResponse);
                }
            })
            .catch(error => {
                const message = (typeof(error.response) !== 'undefined' && error.response.status === 401) ?
                    'Your session has expired and you must login again' :
                    `An error occurred processing your request: ${error.message}`;
                const actionResponse = {
                    error: true,
                    errorMessage: message
                };
                setErrorResponse(actionResponse);
            });
    }
}
